import { CSSProperties, ReactNode } from 'react';
import { DetailFormProps } from '../SuperForm/detailForm';
import { StepsProps } from '../Steps/interface';
import { ButtonGroupProps } from '../ButtonGroup/buttonGroup';
import { RouteLinkProps } from '../RouteLink/interface';
import { OptionItem, OptionItemsType, } from '../constants/interface';

export interface BaseScanPageProps {
  /** 类名 */
  className?: string;
  /** 样式 */
  style?: CSSProperties;
  children?: ReactNode;
}
export interface ScanPageProps extends BaseScanPageProps {};
/** 头部 */
export interface ScanPageHeaderProps extends BaseScanPageProps {
  /** 是否显示语音操作 */
  isVoice?: boolean;
};
/** 头部标题 */
export interface ScanPageHeaderTitleProps extends BaseScanPageProps {
  /** 标题 */
  title?: ReactNode;
  /** 类型名称 */
  typeName?: ReactNode;
  /** 仓库名称 */
  warehouseName?: ReactNode;
  /** 链接props */
  routeLinkProps?: RouteLinkProps;
  /** 提示信息 */
  tootipText?: ReactNode;
  /** 提示图标 */
  tootipIcon?: ReactNode;
  /** 其他信息 */
  otherNode?: ReactNode;
};
/** 头部步骤条 */
export interface ScanPageHeaderStepsProps extends BaseScanPageProps {
  /** 步骤条props */
  stepsProps?: StepsProps;
};
/** 内容 */
export interface ScanPageBodyProps extends BaseScanPageProps {
  children?: ReactNode;
};
/** 左侧 */
export interface ScanPageLeftProps extends BaseScanPageProps {};
/** 左侧 formItem表单 */
export interface ScanPageLeftFormItemProps extends Omit<BaseScanPageProps, 'children'>, Partial<DetailFormProps> {};
/** 左侧 自定义 */
export interface ScanPageLeftCustomProps extends BaseScanPageProps {};
/** 主体 */
export interface ScanPageContentProps extends BaseScanPageProps {};
/** 主体计数 */
export interface ScanPageContentCountProps extends BaseScanPageProps {
  /** 标题 */
  title?: ReactNode;
  /** 副标题 */
  subTitle?: ReactNode;
  /** 设置后置标签 */
  addonAfter?: ReactNode;
  /** 设置前置标签 */
  addonBefore?: ReactNode;
  /** 主体区域内容 */
  count?: ReactNode;
  /** 主体区域内容样式 */
  countType?: 'danger' | 'success' | 'warning' | 'primary';
  /** 单位 */
  unit?: ReactNode;
  /** 是否为数字 */
  isNumber?: boolean;
  /** 字体大小 */
  fontSize?: number;
  /** 字体类名 */
  countClassName?: string;
  /** 字体样式 */
  countStyle?: CSSProperties;
  /** 自定义头部 */
  header?: ReactNode;
};
/** 主体 自定义 */
export interface ScanPageContentCustomProps extends BaseScanPageProps {
  /** 标题 */
  title?: ReactNode;
  /** 设置后置标签 */
  addonAfter?: ReactNode;
  /** 设置前置标签 */
  addonBefore?: ReactNode;
};
/** 右侧 */
export interface ScanPageRightProps extends BaseScanPageProps {};
/** 右侧 操作按钮 */
export interface ScanPageRightOperationProps extends BaseScanPageProps {
  /** 查看按钮组配置 */
  viewButtonGroupProps?: ButtonGroupProps;
  /** 操作按钮组的配置 */
  optionButtonGroupProps?: ButtonGroupProps;
  /** 点击按钮组 */
  onClick?: (key: string) => void;
};
/** 右侧 扫码参数 */
export interface ScanPageRightGoodItemProps extends BaseScanPageProps {
  options?: OptionItemsType[];
};
/** 右侧 扫码商品信息 */
export interface ScanPageRightGoodInfoProps extends BaseScanPageProps {
  imagePath?: string;
  options?: OptionItem[];
};
/** 右侧 自定义 */
export interface ScanPageRightCustomProps extends BaseScanPageProps {};
/** 右侧 RowItem */
export interface ScanPageRightRowItemProps extends BaseScanPageProps {
  options?: OptionItem[];
  /** label宽度 */
  labelWidth?: number;
  /** 标题 */
  title?: ReactNode;
  /** 提示内容 */
  tooltipText?: string;
  /** 提示图标 */
  tooltipIcon?: ReactNode;
};

export enum ScanPageItemEnum {
  Header = 'Header',
  Body = 'Body',
};

export enum ScanPageBodyItemEnum {
  Left = 'Left',
  Content = 'Content',
  Right = 'Right',
};

export enum ScanPageHeaderItemEnum {
  Title = 'Title',
  Steps = 'Steps',
};

export enum ScanPageLeftItemEnum {
  FormItem = 'FormItem',
  Custom = 'Custom',
};

export enum ScanPageContentItemEnum {
  ContentCount = 'ContentCount',
  ContentCustom = 'ContentCustom',
};

export enum ScanPageRightItemEnum {
  RightGoodInfo = 'RightGoodInfo',
  RightGoodItem = 'RightGoodItem',
  RightOperation = 'RightOperation',
  RightCustom = 'RightCustom',
  RightRowItem = 'RightRowItem',
}; 
